import { useEffect } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import { DISABLE_LOCATION_CHANGE_RELOAD } from "redux/reducers/header";
import {
  getCity,
  getCoordinates,
  getStateCode,
} from "redux/selectors/location";
import { encodeLocation } from "utils/syncUrlWithUserLocation";

const useSyncUrlWithLocation = (shopUrlLocationParamEnabled: boolean) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const city = useSelector(getCity);
  const state_code = useSelector(getStateCode);
  const coordinates = useSelector(getCoordinates);

  useEffect(() => {
    if (!shopUrlLocationParamEnabled) {
      return;
    }

    if (city && state_code && coordinates) {
      const encodedLocation = encodeLocation({ city, state_code });
      const currentLocation = router.query.location;

      if (currentLocation !== encodedLocation) {
        // Disable the location change reload from the LocationPicker component since we are handling the reload here
        dispatch({
          type: DISABLE_LOCATION_CHANGE_RELOAD,
        });

        const newQuery = { ...router.query, location: encodedLocation };
        router.push({
          pathname: router.pathname,
          query: newQuery,
        });
      }
    }
  }, [
    shopUrlLocationParamEnabled,
    city,
    state_code,
    coordinates,
    router,
    dispatch,
  ]);
};

export default useSyncUrlWithLocation;
